import { DEFAULT_MAP_STYLE } from "./map-style-utils";

export const MAP_BASE_STYLE = DEFAULT_MAP_STYLE;

export const MAP_BASE_STYLE_OVERRIDES = Object.freeze({
  countryRegion: { borderVisible: false },
  adminDistrict: { borderVisible: false },
  adminDistrict2: { borderVisible: false },
  buildingFootprint: { visible: false },
  roadDetails: { visible: false },
});

export const MAP_MIN_ZOOM = 5;
export const MAP_MAX_ZOOM = 19;

export function clampZoom(value, fallback = 11.5) {
  const zoom = Number(value);
  if (!Number.isFinite(zoom)) {
    return fallback;
  }
  return Math.max(MAP_MIN_ZOOM, Math.min(MAP_MAX_ZOOM, Math.round(zoom)));
}
